/* Only the confirmed TpRUqJ teaser: preserve the form and original activation. */
(function () {
  'use strict';
  if (window.__npTeaserCollision20261019) return;
  window.__npTeaserCollision20261019 = true;
  window.__npTeaserCollision20261019Version = 'native-navigation-v5';

  var selector = '.kl-teaser-TpRUqJ';
  var hiddenClass = 'np-teaser-collision-suppressed';
  var raisedClass = 'np-teaser-avoiding-switcher';
  var languageSelector = '.tl-switcher-container .tl-selections';
  var placements = new WeakMap();
  var watchedPlacements = new WeakSet();
  var placementObserver;
  var mobile = window.matchMedia('(max-width: 767px)');
  var targets = new Set();
  var visibleTargets = new Set();
  var targetObserver;
  var trackingTargets = false;
  var frame = 0;
  var critical = 'h1,h2,h3,h4,h5,h6,[role="heading"],a[href],button,input:not([type="hidden"]),select,textarea,summary,[role="button"],[role="link"],label,img[data-action="url"][data-href],[data-native-href]';

  function intersects(a, b) {
    return b.width > 0 && b.height > 0 &&
      a.left < b.right + 8 && a.right > b.left - 8 &&
      a.top < b.bottom + 8 && a.bottom > b.top - 8;
  }

  function setProperty(element, name, value) {
    if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
  }

  function clearPlacement(teaser) {
    if (teaser.classList.contains(raisedClass)) teaser.classList.remove(raisedClass);
    ['--np-teaser-collision-base-bottom', '--np-teaser-collision-lift'].forEach(function (name) {
      if (teaser.style.getPropertyValue(name)) teaser.style.removeProperty(name);
    });
    placements.delete(teaser);
  }

  function watchPlacement(element) {
    if (!watchedPlacements.has(element)) {
      placementObserver.observe(element, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
      watchedPlacements.add(element);
    }
  }

  function placeAboveLanguageControl(teaser) {
    if (!mobile.matches) {
      clearPlacement(teaser);
      return;
    }
    var style = window.getComputedStyle(teaser);
    var bottom = parseFloat(style.bottom);
    if (style.position !== 'fixed' || !Number.isFinite(bottom)) {
      clearPlacement(teaser);
      return;
    }
    var state = placements.get(teaser);
    var previousLift = state ? state.lift : 0;
    var baseBottom = state ? state.baseBottom : bottom;
    var rect = teaser.getBoundingClientRect();
    var original = {
      left: rect.left, right: rect.right, width: rect.width, height: rect.height,
      top: rect.top + previousLift, bottom: rect.bottom + previousLift
    };
    var lift = 0;
    document.querySelectorAll(languageSelector).forEach(function (control) {
      var container = control.closest('.tl-switcher-container');
      if (!container) return;
      watchPlacement(container);
      watchPlacement(control);
      if (control.closest('[hidden],[aria-hidden="true"]')) return;
      var controlStyle = window.getComputedStyle(control);
      var containerStyle = window.getComputedStyle(container);
      if (containerStyle.position !== 'fixed' || containerStyle.display === 'none' ||
          containerStyle.visibility !== 'visible' || Number(containerStyle.opacity) === 0 ||
          controlStyle.display === 'none' || controlStyle.visibility !== 'visible' ||
          Number(controlStyle.opacity) === 0) return;
      var box = control.getBoundingClientRect();
      if (intersects(original, box)) lift = Math.max(lift, original.bottom - box.top + 8);
    });
    // Reserve space above the real fixed selector, then recheck page collisions.
    // If the viewport cannot fit this placement, keep the original collision rule.
    if (lift <= 0 || original.top - lift < 8) {
      clearPlacement(teaser);
      return;
    }
    placements.set(teaser, { baseBottom: baseBottom, lift: lift });
    setProperty(teaser, '--np-teaser-collision-base-bottom', baseBottom + 'px');
    setProperty(teaser, '--np-teaser-collision-lift', lift + 'px');
    if (!teaser.classList.contains(raisedClass)) teaser.classList.add(raisedClass);
  }

  function isCriticalCollision(element, box) {
    if (element.closest(selector + ',[hidden],[aria-hidden="true"]')) return false;
    var outer = element.getBoundingClientRect();
    if (!intersects(box, outer)) return false;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility !== 'visible' || Number(style.opacity) === 0) return false;

    // Headings/labels use text fragments, not their full-width empty block area.
    if (element.matches('h1,h2,h3,h4,h5,h6,[role="heading"],label')) {
      var range = document.createRange();
      range.selectNodeContents(element);
      var rects = range.getClientRects();
      for (var i = 0; i < rects.length; i++) {
        if (intersects(box, rects[i])) return true;
      }
      return false;
    }
    return true;
  }

  function check() {
    frame = 0;
    var teasers = document.querySelectorAll(selector);
    var shouldTrack = mobile.matches && teasers.length > 0;
    if (shouldTrack && !trackingTargets) {
      trackingTargets = true;
      visitTargets(document.body, true);
    } else if (!shouldTrack && trackingTargets) {
      trackingTargets = false;
      if (targetObserver) targetObserver.disconnect();
      targets.clear();
      visibleTargets.clear();
    }
    teasers.forEach(function (teaser) {
      watchPlacement(teaser);
      placeAboveLanguageControl(teaser);
      var suppress = false;
      var box = teaser.getBoundingClientRect();
      if (mobile.matches && box.width > 0 && box.height > 0) {
        // IntersectionObserver keeps offscreen cards out of the synchronous
        // geometry pass. It also schedules a check as new content enters view.
        var candidates = targetObserver ? visibleTargets : targets;
        for (var target of candidates) {
          if (target.isConnected && isCriticalCollision(target, box)) {
            suppress = true;
            break;
          }
        }
      }
      // Do not remove a currently focused control while a keyboard user uses it.
      if (teaser.contains(document.activeElement)) suppress = false;
      if (teaser.classList.contains(hiddenClass) !== suppress) {
        teaser.classList.toggle(hiddenClass, suppress);
      }
    });
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(check);
  }

  function visitTargets(node, add) {
    if (node.nodeType !== 1) return;
    function visit(element) {
      if (add) {
        if (targets.has(element)) return;
        targets.add(element);
        if (targetObserver) targetObserver.observe(element);
      } else {
        targets.delete(element);
        visibleTargets.delete(element);
        if (targetObserver) targetObserver.unobserve(element);
      }
    }
    if (node.matches(critical)) visit(node);
    node.querySelectorAll(critical).forEach(visit);
  }

  function start() {
    placementObserver = new MutationObserver(schedule);
    if ('IntersectionObserver' in window) {
      targetObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) visibleTargets.add(entry.target);
          else visibleTargets.delete(entry.target);
        });
        schedule();
      }, { rootMargin: '16px' });
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    document.addEventListener('load', schedule, true);
    document.addEventListener('transitionend', schedule, true);
    document.addEventListener('animationend', schedule, true);
    new MutationObserver(function (records) {
      if (trackingTargets) records.forEach(function (record) {
        record.removedNodes.forEach(function (node) { visitTargets(node, false); });
        record.addedNodes.forEach(function (node) { visitTargets(node, true); });
      });
      schedule();
    }).observe(document.body, { childList: true, subtree: true });
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(document.body);
    if (mobile.addEventListener) mobile.addEventListener('change', schedule);
    else mobile.addListener(schedule);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
